module.exports = __webpack_public_path__ + "d20e2b53ca0d7ed14eb673f0b2958efe.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/icons/students-gray.png
// module id = 1703
// module chunks = 0